import { render, staticRenderFns } from "./page-discussions.vue?vue&type=template&id=13ea2ce0&scoped=true"
import script from "./page-discussions.vue?vue&type=script&lang=js"
export * from "./page-discussions.vue?vue&type=script&lang=js"
import style0 from "./page-discussions.vue?vue&type=style&index=0&id=13ea2ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea2ce0",
  null
  
)

export default component.exports